var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21419 12.4001C9.21419 11.4336 9.99769 10.6501 10.9642 10.6501H45.9642C46.9307 10.6501 47.7142 11.4336 47.7142 12.4001V52.0668C47.7142 53.0333 46.9307 53.8168 45.9642 53.8168H10.9642C9.99769 53.8168 9.21419 53.0333 9.21419 52.0668V12.4001ZM12.7142 14.1501V50.3168H44.2142V14.1501H12.7142Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7975 22.3168C24.764 22.3168 25.5475 23.1003 25.5475 24.0668V39.2335C25.5475 40.2 24.764 40.9835 23.7975 40.9835C22.831 40.9835 22.0475 40.2 22.0475 39.2335V24.0668C22.0475 23.1003 22.831 22.3168 23.7975 22.3168Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1309 22.3168C34.0974 22.3168 34.8809 23.1003 34.8809 24.0668V39.2335C34.8809 40.2 34.0974 40.9835 33.1309 40.9835C32.1644 40.9835 31.3809 40.2 31.3809 39.2335V24.0668C31.3809 23.1003 32.1644 22.3168 33.1309 22.3168Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.38086 12.4001C3.38086 11.4336 4.16436 10.6501 5.13086 10.6501H51.7975C52.764 10.6501 53.5475 11.4336 53.5475 12.4001C53.5475 13.3666 52.764 14.1501 51.7975 14.1501H5.13086C4.16436 14.1501 3.38086 13.3666 3.38086 12.4001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4335 4.55895C21.7407 3.99853 22.3289 3.65015 22.968 3.65015H34.0375C34.6819 3.65015 35.2742 4.00432 35.5791 4.57204L39.3392 11.572C39.6305 12.1144 39.6154 12.7699 39.2995 13.2983C38.9835 13.8267 38.4132 14.1501 37.7975 14.1501H19.1309C18.5126 14.1501 17.9402 13.8239 17.6251 13.2919C17.31 12.7599 17.2991 12.1011 17.5963 11.5589L21.4335 4.55895ZM24.0044 7.15015L22.0858 10.6501H34.871L32.991 7.15015H24.0044Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.63e91de2.svg";
export { ForwardRef as ReactComponent };